import { useState, useEffect } from 'react';
import api from '../services/api';
import usePaymentAlerts from './usePaymentAlerts';

const useNotifications = (user) => {
  const [summary, setSummary] = useState({ pedidosOracao: 0, preCadastros: 0, novosUsuarios: 0 });
  const paymentAlerts = usePaymentAlerts(user?.role);

  const isSecretaria = ['secretario', 'pastor', 'administracao'].includes(user?.role);

  const fetchSummary = async () => {
    if (!isSecretaria) return;
    try {
      const res = await api.get('/notifications/summary');
      setSummary(res.data || {});
    } catch { /* silent */ }
  };

  useEffect(() => {
    fetchSummary();
    const interval = setInterval(fetchSummary, 60 * 1000);
    return () => clearInterval(interval);
  }, [user?.role]);

  const total =
    (isSecretaria ? (summary.pedidosOracao || 0) + (summary.preCadastros || 0) : 0) +
    (paymentAlerts.alertCount || 0);

  return {
    total,
    summary,
    fixedExpenses: paymentAlerts.fixedExpenses,
    hasFinancialPermission: paymentAlerts.hasFinancialPermission,
    isSecretaria,
    refresh: fetchSummary
  };
};

export default useNotifications;
